/* eslint-disable  */
import axios from 'axios';
const uri = "wss://replay-engine.herokuapp.com/";
const domain = "https://replay-engine.herokuapp.com/";


let playSessionID = "SET_FROM_SINATRA";
let ws = null;
let replayFrames = null;
let unityConentRecorder = null;
window.cmraData = () => exportData();
function connectWebSocket () {

	if (ws == null) {
		ws = new WebSocket(uri);
		unityConentRecorder.on('DataCollection', (message) => {
			recordData(message);
		})
		ws.onmessage = message => {
			intializationMessage(message)
		};
	}
	else {
		const outgoing = {
			topic: 'data_log',
			message: {
				method: 'session_started',
			}
		};
		unityConentRecorder.send('UnityMessenger', 'UnityMessengerDispatcher', JSON.stringify(outgoing));
	}
}

function setUnityContent (unity) {
	unityConentRecorder = unity;
}

function intializationMessage (message) {
	// Set the ID for the first message ony
	playSessionID = JSON.parse(message.data).play_session_id;
	const outgoing = {
		topic: 'data_log',
		message: {
			method: 'session_started',
		}
	};
	unityConentRecorder.send('UnityMessenger', 'UnityMessengerDispatcher', JSON.stringify(outgoing));
	// reset ws.
	ws.onmessage = dataMessageRecived(message);
}
function dataMessageRecived (message) {
	const data = JSON.parse(message.data);
}

function exportData () {
	axios({
		url: domain + `/session/${playSessionID}`
	}).then(function (response) {
		// handle success
		console.log("response", response);
		replayFrames = response.data;
		console.log("Session frames", replayFrames);
		for (let index = 0; index < replayFrames.frames.length; index++) {
			console.log("frame " + index, JSON.parse(replayFrames.frames[index].toString()));
		}
		console.log("frames", JSON.parse(replayFrames.frames.toString()));
	}).catch(function (error) {
		// handle error
		console.log(error);
	})
}

function recordData (data) {

	if (ws != null) {
		var signedData = JSON.parse(data);

		signedData.domain = window.location.toString();

		if (ws.readyState == 1) {

			ws.send(JSON.stringify(signedData));
		}
	}
}

export { connectWebSocket, exportData, setUnityContent, recordData };